import { Quote } from 'lucide-react';
import Container from '../ui/Container';

export default function TeamTestimonials() {
  return (
    <section className="py-12">
      <Container>
        <div className="max-w-3xl mx-auto text-center">
          <Quote className="w-10 h-10 text-brown-600 mx-auto mb-4" />
          <blockquote className="text-xl text-gray-600 italic mb-3">
            "Working at BNC has been an incredible journey. The collaborative environment and meaningful projects have truly shaped my career."
          </blockquote>
          <p className="text-sm text-gray-500">Employee Testimonial</p>
        </div>
      </Container>
    </section>
  );
}